import { User } from "../../business-objects/user/user.model";
import { Component, HostBinding } from "@angular/core";
import { BaseComponent } from "../../../core/components/base.component";
import { Popover, PopoverController } from "ionic-angular";
import { VasAppFacade } from "../../services/vas-app-facade.service";
import { UserPopoverNavParams } from "../../modals/user-popover/user-popover";

@Component({
    selector: "user-popover-button",
    template: `
        <button
            *ngIf="user"
            ion-button
            clear
            class="user-popover-button"
            (click)="onShowUserPopover($event)"
        >
            {{firstLetter}}
        </button>
    `
})
export class UserPopoverButtonComponent extends BaseComponent {

    @HostBinding("attr.data-letter") firstLetter: string = "";

    protected user: User;

    displayedPopover: Popover;

    constructor(protected appFacade: VasAppFacade, protected popoverController: PopoverController) {
        super();
    }

    ngOnInit(): void {
        this.appFacade.objects.user.store
            .getActive()
            .takeUntil(this.ngUnsubscribe)
            .subscribe(user => {
                this.user = user;
                this.firstLetter = this.getFirstLetter(user);
            });
    }

    getFirstLetter(user: User): string {

        if (!user) {
            return "";
        } else if (user.name) {
            return user.name.charAt(0).toUpperCase();
        } else if (user.email) {
            return user.email.charAt(0).toUpperCase();
        } else {
            return "?";
        }
    }

    onShowUserPopover($event): void {
        this.displayedPopover = this.popoverController.create("UserPopoverComponent", { popoverButton: this } as UserPopoverNavParams);

        this.displayedPopover.present({
            ev: $event
        });
    }
}



// WEBPACK FOOTER //
// ./src/vas/modules-other/user-popover-button/user-popover-button.component.ts